<template>
    <ul class="form_list">
        <li class="title">
            {{ $t('reservation_settings.popup_staff_settings.label_bold_line_display') }}
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">시간표에 표시되는 굵은선 표시 기준을 설정할 수 있습니다.</span>
            </span>
        </li>
        <li class="cont">
            <div class="form_list">
                <select class="input_s w_full"
                        :value="interval"
                        :disabled="isDirectSetting"
                        @change="updateValue('boldInterval', Number($event.target.value))">
                    <option value="10">{{ $t('reservation_settings.popup_staff_settings.label_bold_line_display_10min') }}</option>
                    <option value="15">{{ $t('reservation_settings.popup_staff_settings.label_bold_line_display_15min') }}</option>
                    <option value="20">{{ $t('reservation_settings.popup_staff_settings.label_bold_line_display_20min') }}</option>
                    <option value="30">{{ $t('reservation_settings.popup_staff_settings.label_bold_line_display_30min') }}</option>
                    <option value="60">{{ $t('reservation_settings.popup_staff_settings.label_bold_line_display_60min') }}</option>
                </select>
                <label class="check_wrap">
                    <input type="checkbox" v-model="isDirectSetting">
                    <span class="checkmark"></span>
                    {{ $t('reservation_settings.popup_staff_settings.label_bold_line_display_custom_entry') }}
                </label>
            </div>
            <div class="table2_xyscroll sticky" style="height: 180px;" v-if="isDirectSetting">
                <table class="table2_default pd_small">
                    <thead>
                    <tr>
                        <th style="width: 220px;">{{ $t('reservation_settings.popup_staff_settings.label_bold_line_criteria') }}</th>
                        <th>{{ $t('reservation_settings.popup_staff_settings.label_delete') }}</th>
                    </tr>
                    </thead>
                    <tbody v-if="(boldTimeIntervals?.length ?? 0) == 0">
                    <tr>
                        <td class="txt_center lgray_txt" colspan="2">
                            {{ $t('reservation_settings.popup_staff_settings.placeholder_bold_line_criteria') }}
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-if="(boldTimeIntervals?.length ?? 0) > 0">
                    <Item
                        v-for="(t, index) in boldTimeIntervals" :key="index"
                        :value="t"
                        :index="index"
                        @updateItem="updateItem"
                        @removeItem="removeItem"
                    />
                    </tbody>
                    <tr>
                        <td class="txt_center" colspan="2">
                            <button class="btn btn_s btn_blue_line" @click="action_Add">＋ {{ $t('reservation_settings.popup_staff_settings.label_add') }}</button>
                        </td>
                    </tr>
                </table>
            </div>
            <small class="red_txt" v-if="isErrorBoldTime">표시 기준을 최소 1개 이상 입력해 주세요.</small>
            <small class="red_txt" v-if="isErrorDuplicatedBoldTime">같은 시간으로 입력된 항목이 있습니다.</small>
        </li>
    </ul>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import Item from './Items/BoldTimeItem.vue'

export default {
    components: { Item },
    props: {
        usingDefaultBoldInterval: Boolean,
        boldInterval: Number,
        boldTimeIntervals: Array,

        isErrorBoldTime: Boolean,
        isErrorDuplicatedBoldTime: Boolean
    },
    data() {
        return {
            interval: 60,
            isDirectSetting: false
        }
    },
    watch: {
        usingDefaultBoldInterval: {
            immediate: true,
            handler: function(newValue) {
                this.isDirectSetting = (newValue ?? true) == false
            }
        },
        boldInterval: {
            immediate: true,
            handler: function(newValue) {
                this.interval = newValue
            }
        },
        isDirectSetting: {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) {
                    return
                }
                this.clearError()
                this.updateValue('usingDefaultBoldInterval', !newValue)
            }
        }
    },
    methods: {
        action_Add() {
            let intervals = deepCopy(this.boldTimeIntervals)
            intervals.push('00:00')
            this.clearError()
            this.updateValue('boldTimeIntervals', intervals)
        },
        updateItem(index, item) {
            let intervals = deepCopy(this.boldTimeIntervals)
            intervals = intervals.slice(0, index)
                .concat([item])
                .concat(intervals.slice(index + 1))
            this.clearError()
            this.updateValue('boldTimeIntervals', intervals)
        },
        removeItem(index) {
            let intervals = deepCopy(this.boldTimeIntervals)
            intervals = intervals.splice(0, index).concat(intervals.slice(index + 1))
            this.clearError()
            this.updateValue('boldTimeIntervals', intervals)
        },
        updateValue(key, value) {
            let data = {
                key: key,
                value: value
            }
            this.$emit('updateValue', data)
        },
        clearError() {
            this.$emit('clearError', 'isErrorBoldTime')
            this.$emit('clearError', 'isErrorDuplicatedBoldTime')
        }
    }
}

</script>